import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  Stage: null,
  BidAmount: null,
};

const stageSlice = createSlice({
  name: "bidwizardStage",
  initialState,
  reducers: {
    setWizardData: (state, action) => {
      state.Stage = action.payload;
    },
    setBidAmount: (state, action) => {
      state.BidAmount = action.payload;
    },
  },
});
export const { setWizardData, setBidAmount } = stageSlice.actions;
export default stageSlice.reducer;
